module.exports = __webpack_public_path__ + "images/menu_membership_card.svg";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__mhf/images/menu_membership_card.svg
// module id = /tool/node_modules/file-loader/dist/cjs.js??ref--1-0!/tool/node_modules/img-loader/index.js??ref--1-1!/tool/project/client/src/site__mhf/images/menu_membership_card.svg
// module chunks = site__mhf